<div class="modal-header" *transloco="let t; prefix: 'compliance.shared.modals.reschedule'">
  <h5 class="modal-title">{{ t('title') }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'compliance.shared.modals.reschedule'">
  <p class="modal-description">{{ t('description') }}</p>
  <form [formGroup]="rescheduleForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <app-flatpickr-date-picker
        [label]="t('dateLabel')"
        [value]="dateValue"
        [minDate]="'today'"
        [dateFormat]="dateFormat"
        [altFormat]="dateFormat"
        [enableTime]="enableTime"
        [required]="true"
        (valueChange)="onDateChange($event)">
      </app-flatpickr-date-picker>
      @if (rescheduleForm.get('date')?.invalid && rescheduleForm.get('date')?.touched) {
        <div class="error-message">{{ t('dateRequired') }}</div>
      }
    </div>

    @if (showNotifyPersonResponsible) {
      <div class="form-group checkbox-group">
        <input
          type="checkbox"
          id="notifyPersonResponsible"
          class="form-check-input"
          formControlName="notifyPersonResponsible">
        <label for="notifyPersonResponsible" class="checkbox-label">{{ t('notifyPersonResponsible') }}</label>
      </div>
    }

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>
      <button type="submit" class="reschedule-btn" [disabled]="isSubmitDisabled">
        @if (isLoading) {
          <span class="spinner-border"></span>
        }
        @if (!isLoading) {
          <span>{{ t('submit') }}</span>
        }
      </button>
    </div>
  </form>
</div>